import React from "react";
import PropTypes from "prop-types";
import GenericDialog from "components/ui/dialogs/generic-dialog/GenericDialog";
import {Button, Typography} from "@material-ui/core";

const SegnalazioneInviataDialog = (props) => {
    const dialogContent = (
        <React.Fragment>
            <Typography variant="body2">
                La tua segnalazione è stata inviata correttamente. Riceverai una riposta nel più breve tempo possibile.
            </Typography>
        </React.Fragment>
    );

    const dialogActions = (
        <React.Fragment>
            <Button onClick={props.handleDialogClose} color="primary">
                <div className="align-center-x px-16">Richieste e assistenza</div>
            </Button>
            <Button onClick={props.handleDialogClose} color="primary" variant="contained">
                <div className="align-center-x px-16">Chiudi</div>
            </Button>
        </React.Fragment>
    );

    return (
        <GenericDialog
            dialogWidth="xs"
            open={props.open}
            handleDialogClose={props.handleDialogClose}
            handleDialogCloseButton={props.handleDialogCloseButton}
            dialogContent={dialogContent}
            dialogActions={dialogActions}
        >
            <Typography variant={"h6"}>Segnalazione inviata</Typography>
        </GenericDialog>
    );
};

SegnalazioneInviataDialog.propTypes = {
    handleDialogClose: PropTypes.func,
    handleDialogCloseButton: PropTypes.func,
    open: PropTypes.bool
};

export default SegnalazioneInviataDialog;
